import React, { useState, useEffect } from "react";

const EventForm = () => {
  const [bowlers, setBowlers] = useState([]);
  const [scores, setScores] = useState([0, 0, 0]); // Initialize with three games

  useEffect(() => {
    // Simulate fetching data
    const fetchBowlers = async () => {
      // Example fetch logic
      const response = await fetch("/api/bowlers"); // Update with your API
      const data = await response.json();
      setBowlers(data);
    };
    fetchBowlers();
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold">Event Form</h2>
      {bowlers.length > 0 ? (
        <div>
          {/* Your form logic here */}
          {bowlers.map((bowler, index) => (
            <div key={index}>
              <h3>{bowler.name}</h3>
              {/* Additional logic */}
            </div>
          ))}
        </div>
      ) : (
        <p>No bowlers available.</p>
      )}
      <div>
        <h3>Enter Scores:</h3>
        {scores.map((score, index) => (
          <input
            key={index}
            type="number"
            value={score}
            onChange={(e) => {
              const newScores = [...scores];
              newScores[index] = Number(e.target.value);
              setScores(newScores);
            }}
            placeholder={`Game ${index + 1} Score`}
          />
        ))}
      </div>
    </div>
  );
};

export default EventForm;
